import { useEffect } from "react";
import { api } from "../lib/api";
import { checkVersionOnFocus, useNewVersion } from "../lib/version";
import { common } from "@pagemates/shared/copy";

const txt = common.updateBanner;

let watching = false;

/** A new release is live: one quiet line at the top; tapping it reloads. Nothing happens until it's tapped. */
export function UpdateBanner() {
  const newer = useNewVersion();
  useEffect(() => { if (!watching) { watching = true; checkVersionOnFocus(() => api.health()); } }, []);
  if (!newer) return null;
  return <button type="button" className="update-banner" onClick={() => location.reload()}>{txt.updatedTapToRefresh}</button>;
}
